/*
Used to load discount on the <custom-promo> custom element.
Used to update class on each cart update.

snippets/custom-promotions.liquid is used to display the container and this file load the content

By Clément, from Galadrim.
*/

class customPromo extends HTMLElement {
  constructor() {
    super();
    // Used to apply a different layout on grid context : Only the most easily accessible discount
    this.context = this.dataset.context;

    if (!this.context) return;

    if (this.context == "main-product") {
      this.qttEl = this.closest(".product-main").querySelector(".quantity-selector__input");
      this.qttPlus = this.closest(".product-main").querySelector(".quantity-selector__button--plus");
      this.qttMinus = this.closest(".product-main").querySelector(".quantity-selector__button--minus");
    }

    if (this.dataset.logged == "true") this.build();
  }

  build() {
    if (this.dataset.show == "false") return;
    this.querySelectorAll(".custom-promo-el").forEach(el => el.remove());
    try {
      const promos = this.getPromos();
      if (!promos) return;

      promos.forEach(promo => {
        this.buildPromo(promo);
      });

      const cartContainer = this.closest(".cart-item--inner");
      if (cartContainer) {
        cartContainer.style.setProperty("--promo-h", `${this.offsetHeight}px`);
      }

      this.updateFreeItemAvailability(window.Shopify.validIds);
    } catch (err) {
      console.error(this.dataset.handle, err);
    }
  }

  buildPromo(promo) {
    if (!promo) return;
    if (Array.isArray(promo.restrictedToPriceCodes)) {
      if (!promo.restrictedToPriceCodes.includes(this.dataset.priceCode)) return;
    }

    if (Array.isArray(promo.restrictedToCompanies)) {
      if (!promo.restrictedToCompanies.includes(this.dataset.companyId)) return;
    }
    // Build all the discounts and prepend them on the container
    const abs = promo.type === "FREE_ITEM" ? "CADEAU" : "OFFRE SPÉCIALE";

    let title;

    if (promo.type == "FREE_ITEM") title = `${promo.minimumQuantity}+${promo.freeItemDiscount.freeItemQuantity}`;
    else if (promo.type == "BUY_X_GET_Y")
      title = `${promo.minimumQuantity - promo.buyXGetYDiscount.freeItemQuantity}+${promo.buyXGetYDiscount.freeItemQuantity}`;
    else if (promo.type == "PERCENTAGE") title = `-${promo.percentageDiscount.percentage}%`;
    else if (promo.type == "FIXED_AMOUNT") title = `-${promo.fixedAmountDiscount.amount}€`;

    const el = document.createElement("div");
    el.dataset.id = promo.id;
    el.dataset.type = promo.type;
    el.classList = `custom-promo-el`;

    this.isApplied(el, promo);

    el.innerHTML = `
            <div class="cp-icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66699 6.66669H6.67533M1.66699 4.33335L1.66699 8.06212C1.66699 8.46977 1.66699 8.67359 1.71304 8.86541C1.75387 9.03547 1.82121 9.19804 1.91259 9.34716C2.01566 9.51536 2.15979 9.65948 2.44804 9.94773L8.83856 16.3383C9.82861 17.3283 10.3236 17.8233 10.8944 18.0088C11.3966 18.1719 11.9374 18.1719 12.4395 18.0088C13.0104 17.8233 13.5054 17.3283 14.4954 16.3383L16.3386 14.4951C17.3286 13.5051 17.8236 13.0101 18.0091 12.4392C18.1722 11.9371 18.1722 11.3963 18.0091 10.8941C17.8236 10.3233 17.3286 9.8283 16.3386 8.83826L9.94804 2.44774C9.65979 2.15948 9.51566 2.01536 9.34746 1.91229C9.19834 1.82091 9.03577 1.75357 8.86571 1.71274C8.6739 1.66669 8.47007 1.66669 8.06242 1.66669L4.33366 1.66669C3.40024 1.66669 2.93353 1.66669 2.57701 1.84834C2.26341 2.00813 2.00844 2.2631 1.84865 2.5767C1.66699 2.93322 1.66699 3.39993 1.66699 4.33335ZM7.08366 6.66669C7.08366 6.89681 6.89711 7.08335 6.66699 7.08335C6.43687 7.08335 6.25033 6.89681 6.25033 6.66669C6.25033 6.43657 6.43687 6.25002 6.66699 6.25002C6.89711 6.25002 7.08366 6.43657 7.08366 6.66669Z" stroke="#AA803C" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
            <div class="cp-title">${title}</div>
            <div class="cp-desc">${promo.description}</div>
            <div class="cp-abs">${abs}</div>
        `;
    this.prepend(el);
  }

  isApplied(el) {
    el.classList.remove("active");
    const promoId = el.dataset.id;
    const appliedPromos = document.querySelector("#cart-applied-promos").value.split("///");
    appliedPromos.forEach(p => {
      if (p != "") {
        const handle = p.split("::")[0];
        p.split("::")[1]
          .split(",")
          .forEach(subP => {
            const id = subP.split(":")[1];
            if (handle == this.dataset.handle && id == promoId) el.classList.add("active");
          });
      }
    });
  }

  getPromos() {
    // Get the promo from the script tag on the snippet.
    const data = this.querySelector("#custom-promotions-data");
    if (!data) return null;
    const content = data.textContent.trim();
    if (!content || content == "") return null;
    // Parse it to JSON and return value
    return JSON.parse(content);
  }

  update() {
    if (this.dataset.context == "cart") return;

    this.querySelectorAll(".custom-promo-el").forEach(el => {
      this.isApplied(el);
    });
  }

  updateFreeItemAvailability(validIds) {
    const promoEls = this.querySelectorAll(".custom-promo-el");

    const isSet = validIds instanceof Set;

    promoEls.forEach(el => {
      if (el.dataset.type == "FREE_ITEM") {
        const promoId = el.dataset.id;

        const isValid = isSet ? validIds.has(promoId) : Array.isArray(validIds) ? validIds.includes(promoId) : false;

        if (isValid) {
          el.classList.remove("soldout");
        } else {
          el.classList.add("soldout");
        }
      }
    });
  }
}
customElements.define("custom-promo", customPromo);

document.addEventListener("cart:newcart", () => document.querySelectorAll("custom-promo").forEach(el => el.update()));
window.addEventListener("free-item:checked-availability", e => {
  window.Shopify.validIds = e.detail.validDiscountIds || [];
  document.querySelectorAll("custom-promo").forEach(el => {
    el.updateFreeItemAvailability(window.Shopify.validIds);
  });
});
